export const PVD_ME_STORAGE_KEY = 'pvd-api-v1-me'

const SESSION_COOKIE_NAMES = ['bearer', 'bearer_expires', 'bearer_refresh', 'rasuwa'] as const

export const clearPavedClientAuth = (): void => {
  if (typeof document === 'undefined') return

  const expire = 'Thu, 01 Jan 1970 00:00:01 GMT'
  for (const name of SESSION_COOKIE_NAMES) {
    document.cookie = `${name}=;expires=${expire};path=/`
  }

  try {
    localStorage.removeItem(PVD_ME_STORAGE_KEY)
  } catch {
    return
  }
}
